<div class="banner" role="banner">
  <h1>{{ 'faq.page.title' | translate }}</h1>
</div>

<div class="container">
  <fgbcl-faq-section></fgbcl-faq-section>
</div>
